const BASE = "https://static.prod-images.emergentagent.com/jobs/4b4c840f-8012-467a-b484-07c3bd9dc660/images";

export const AI_IMAGES = {
  core: `${BASE}/883c90b3657a5109a62dbd04469a7a5fee202570083d940d562a247d87814a90.jpeg`,
  humanAi: `${BASE}/596b517c6158f5a55e267e6e9ada86333e58acd80ae89602c4288fb008309a8b.jpeg`,
  ecosystem: `${BASE}/a745ac7a7353516d5bb9d7c879b812779cebb23797bf396fdb1346544a01afc5.jpeg`,
  sales: `${BASE}/b58862bbf180ac48a0fc2d03d1558f931fefa5be49ef11419d67c4db0b5af87f.jpeg`,
  support: `${BASE}/5bfbc3bd1e081ca40805a4c1f641cf5bc1287bfa1fe980599579b719a309dd4c.jpeg`,
  research: `${BASE}/20af90afbcc892a920b1f72ecc0c568ba286ab494062aa1a59147d2599a0b881.jpeg`,
  recruitment: `${BASE}/edea21edd01f0872bc4362ce5fc6ccd76383c0ef1e419c700454491703b97b11.jpeg`,
  operations: `${BASE}/d05ec5e8c6080b74ec2905a629f6450d2436b3609cbb8d557b7aa75ed0cfcd33.jpeg`,
  personal: `${BASE}/34236e8a4d4bf922da323b73d08edec245ec96dcbcd6411019a1a334ccc831c6.jpeg`,
};

export const CAREER_ICONS = [
  `${BASE}/fa0dec7694d99c15758e676de7c0bb558f86e66adef201a3fd01ff55d1933897.jpeg`,
  `${BASE}/5c2cda5d54f2920d3146a8dfb4ec97823e56c6b931bfaff319bfc5d1cc6831da.jpeg`,
  `${BASE}/332aee043e195bd5b4581b7be39d4c03c124696753d9f27742d8510c83a8cf84.jpeg`,
  `${BASE}/84c9d8420234856f6a9b9c5ce4d6e64eefcd437331d789f750834c19b9f26f0c.jpeg`,
  `${BASE}/9bbc98dafb5a45a05bb4c4d5d7d15c341d33b930b556a48a1b9f775effd5a9af.jpeg`,
  `${BASE}/ef83b31ff884df45f0ed56fd1a58d1248c99580a99c7e00b2b388c63a90c2898.jpeg`,
  `${BASE}/fc725673e84c5badbf695ad9bc8bf61917f6eecbb756a3057ef6e596d06747dc.jpeg`,
  `${BASE}/1759c0521e922261c21556bd7a66b5a3e050540d399ed91b85bb596c25aca1e0.jpeg`,
  `${BASE}/6d628c08e892cdab736701276f294d1b687586df4fefe8162555986418c86ac4.jpeg`,
];
